import { Card } from "antd";
import React from "react";
// import { AiOutlineCloseCircle } from "react-icons/ai";


const Popout = ({ children, showPopout, setShowPopout, popOutStyles, cardStyles={} }) => {
  if (!showPopout) return null;
  return (
    <div className="popover-modal" style={{...popOutStyles}} onClick={() => setShowPopout(false)}>
      <Card
        onClick={e => e.stopPropagation()} // Preenting closing popover if user clicks ont he card
        // extra={<AiOutlineCloseCircle onClick={() => setShowPopout(false)}/>}
        style={{
          width: 300,

          padding: '0',
          borderRadius: "4px",
          boxShadow:
            "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.19)",
            ...cardStyles
        }}
      >
        {children}
      </Card>
    </div>
  );
};

export default Popout;
